<!-- Responsibility: Implement scene journal behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<scene-journal>
    <div class="scene-journal" if={ props.visible } role="log" aria-label="Scene chronicle">
        <div each={ entry in props.entries } class="recent-entry { entry.isLatest ? 'latest' : 'older' }">
            <div if={ entry.temporalDivider } class="scene-temporal-divider">
                <span>{ entry.temporalLabel }</span>
            </div>
            <div class="scene-meta">
                <span if={ entry.isLatest } class="scene-current-marker">Latest</span>
                <span class="scene-location">{ entry.location }</span>
                <span class="scene-time">{ entry.time }</span>
                <span if={ entry.isUnread } class="scene-new-marker" aria-live="polite">New</span>
            </div>
            <div
                class={ entry.isLatest ? 'scene-prose-live' : '' }
                role={ entry.isLatest ? 'status' : undefined }
                aria-live={ entry.isLatest ? 'polite' : undefined }
                aria-relevant={ entry.isLatest ? 'additions text' : undefined }
                aria-atomic={ entry.isLatest ? 'false' : undefined }
            >
                <raw-html class="scene-prose" mode="prose" content={ entry.text }></raw-html>
            </div>
        </div>
        <div class="scene-empty" if={ !props.entries?.length }>Chronicle initializing...</div>
    </div>
    <button class="down" onclick={scrollToEnd}>&#8659;</button>
    <button class="up" onclick={scrollToStart}>&#8684;</button>

    <script>
        import RawHtml from '../components/raw-html.riot'

        export default {
            components: {RawHtml},
            lastEntryCount: 0,
            userScrolledUp: false,
            scrollDebounce: null,

            onMounted() {
                this.lastEntryCount = (this.props.entries || []).length
                setTimeout(() => this.scrollToEnd(), 200)
                const el = this.$('.scene-journal')
                if (el) {
                  el.addEventListener('scroll', () => {
                    // Mark scrolled-up immediately to prevent auto-scroll race during streaming
                    const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 40
                    if (!isAtBottom) this.userScrolledUp = true
                    // Debounce the "back at bottom" detection
                    clearTimeout(this.scrollDebounce)
                    this.scrollDebounce = setTimeout(() => {
                      const isScrolledToEnd = el.scrollHeight - el.scrollTop <= el.clientHeight + 40
                      if (isScrolledToEnd) this.userScrolledUp = false
                    }, 200)
                  })
                }
            },
            onUpdated() {
                const currentCount = (this.props.entries || []).length
                if (currentCount > this.lastEntryCount) {
                    this.lastEntryCount = currentCount
                    if (!this.userScrolledUp) this.scrollToEnd()
                } else if (currentCount < this.lastEntryCount) {
                    this.lastEntryCount = currentCount
                }
            },
            scrollToEnd() {
                this.userScrolledUp = false;
                const el = this.$('.scene-journal')
                if (!el) return
                el.scrollTo({
                    top: el.scrollHeight,
                    behavior: 'smooth',
                })
            },
            scrollToStart() {
                const el = this.$('.scene-journal')
                if (!el) return
                el.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                })
            },

        }
    </script>
    <style>
        :host {
            display: flex;
            flex: 1 1 auto;
            height: 100%;
            min-height: 0;
            min-width: 0;
            position: relative;

            .scene-journal {
                flex: 1 1 auto;
                min-height: 0;
                overflow-y: scroll;
            }

            .recent-entry {
                content-visibility: auto;
                contain-intrinsic-size: 0 6.25rem;
            }

            > button {
                position: absolute;
                border: 0.125rem solid var(--border);
                width: auto;
                height: auto;
                backdrop-filter: none;
                font-size: 1.2em;
                opacity: 0.5;
                right: 0.5em;
                transform: skewY(-18deg);
                font-weight: bolder;
                background: transparent;
                color: var(--chip-item-fg);
                &.up {
                    top: 0.5em;
                }

                &.down {
                    bottom: 0.5em;
                }
            }
        }
    </style>
</scene-journal>
